import { styled } from '@mui/material';
import React from 'react';

styled('button')({
    marginLeft: 6,
    height: 55,
    width: 250,
    color: '#fff',
    border: 'none',
    outline: 'none',
    fontSize: 22,
    fontWeight: 500,
    cursor: 'pointer',
    position: 'relative',
    backgroundColor: 'transparent',
    span: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        borderRadius: 200,
        width: '100%',
    },
    'span:nth-child(2)': {
        display: 'grid',
        placeItems: 'center',
        transform: 'translate(-6px, -6px)',
        transition: 'transform 0.2s ease-in-out',
    },
    '&:hover': {
        'span:nth-child(2)': {
            transform: 'translate(-3px, -3px)',
        },
    },
    '&:active': {
        'span:nth-child(2)': {
            transform: 'translate(0, 0)',
        },
    },
});
var BorderButtonContainer = styled('button')(function (_a) {
    var theme = _a.theme;
    return ({
        outline: 'none',
        height: 47,
        cursor: 'pointer',
        borderRadius: 50,
        backgroundColor: '#fff',
        border: "2px solid ".concat(theme.palette.primary.main),
        color: theme.palette.primary.main,
        fontFamily: 'Poppins',
        fontSize: 18,
        fontWeight: 600,
        marginRight: 6,
        paddingLeft: 30,
        paddingRight: 30,
        transition: 'all 0.4s',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
    });
});
var BrandClubBorderButton = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 153 : _b, buttonText = _a.buttonText, onClick = _a.onClick;
    return (React.createElement(BorderButtonContainer, { style: { width: width }, onClick: onClick }, buttonText));
};

export { BrandClubBorderButton };
//# sourceMappingURL=index.js.map
